import {useReducer} from 'react'

function useMapLocations() {
    const [locationState, toggleHover] = useReducer((state, name) => {
        return {
            ...state,
            hovered: {
                ...state.hovered, 
                [name]: !state.hovered.[name]
            }
        }
    },
    {
        locations: [
            {
                name: 'office',
                logo: 'fas fa-search',
                text: "Professor's Office",
            },
            {
                name: 'library',
                logo: 'fas fa-book',
                text: "Library",
            },
            {
                name: 'laboratory',
                logo: 'fas fa-flask',
                text: "Laboratory",
            },
            {
                name: 'fourJokers',
                logo: 'fas fa-dice',
                text: "Four Jokers",
            },
            {
                name: 'lastStand',
                logo: 'fas fa-skull-crossbones',
                text: "Last Stand",
            }
        ],
                                                    
        hovered: {
            office: false,
            library: false,
            laboratory: false,
            fourJokers: false,
            lastStand: false
        }
    })
        
    return [locationState, toggleHover]
}

export default useMapLocations